import { z } from 'zod';

/**
 * Vite inlines `import.meta.env` at build time, so a missing variable is a build
 * artefact that fails at runtime. Validating here turns that into one clear
 * error at startup instead of an undefined URL deep in a request.
 */
const envSchema = z.object({
  VITE_API_BASE_URL: z.string().min(1).default('/api/v1'),
  VITE_APP_NAME: z.string().min(1).default('Periscope Admin'),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  const details = parsed.error.issues
    .map((issue) => `  - ${issue.path.join('.')}: ${issue.message}`)
    .join('\n');
  throw new Error(`Invalid frontend environment:\n${details}`);
}

export const env = Object.freeze({
  apiBaseUrl: parsed.data.VITE_API_BASE_URL,
  appName: parsed.data.VITE_APP_NAME,
  isDev: import.meta.env.DEV,
});
